import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesRegisteredApplicationComponent } from './sales-registered-application.component';
import { PrimengModule } from '../../shared/primeng-module/primeng.module';
import { LibraryModule } from 'library';

@NgModule({
  declarations: [
    SalesRegisteredApplicationComponent
  ],
  imports: [
    CommonModule,
    PrimengModule,
    LibraryModule
  ],
  exports: [
    SalesRegisteredApplicationComponent
  ]
})
export class SalesRegisteredApplicationModule { }